// Angular + External
import { Component, ViewEncapsulation, OnInit } from "@angular/core";
import { Router } from "@angular/router";
// BFX

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-not-authorized",
  templateUrl: "./html/not-authorized.component.html",
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class PageNotAuthorizedComponent {
  public get frameTag() {
    return document.body.dataset.frameTag;
  }

  constructor(private _router: Router) {}

  public reroute(route: string): void {
    window.location.replace("/");
    //this._router.navigate([route]);
  }
}
